let plugins = ['tk', 'index', 'vuexStorage']
plugins = [
  ...plugins,
  'user',
  'routerAuth',
  'routerMeta'
]
const config = {
  vuexStorageKeys: [
    'sessionToken',
    'user'
  ],
  plugins: plugins,
  version: '1.0.0', // app版本号
  apiUrl: 'https://cloud.hongshang.mokekeji.com',
  // apiUrl: 'http://192.168.50.206:3333',
  appID: 'Vdfgddjgyg9w5txk',
  restKey: 'Vdjcgy9w5txk',
  masterKey: 'cncWs8wveEvo',
  statusBarColor: 'rgba(255, 255, 255, 0)',
  mobileView: true,
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon'),
  // moke
  payId: '',
  paysecret: '',
  // 客户
  mpAppid: 'wxaa6c3db3f592dae3',
  // 测试
  // mpAppid: 'wx857c47cac29144e3',
}
export default config
